import React from 'react'

const ExtraMessage = ({message}) => {
    return (
        <div>
            <p style={{marginTop:"20px",color:"#fff",fontSize:"18px"}}>Extras are {message}</p>
        </div>
    )
}

export default ExtraMessage
